








































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Translation } from '@/types';
import { debounce, uniq } from 'lodash';
import NewTranslation from '@/components/Translations/components/NewTranslation.vue';
import BaseTable from '@/components/Common/mixins/BaseTable.vue';
import TranslationItem from './components/TranslationItem.vue';
import { State, Getter } from 'vuex-class';
import {
  TRANSLATIONS_ADD_TRANSLATIONS,
  TRANSLATIONS_UPDATE_FILTER_NAMESPACE,
  TRANSLATIONS_UPDATE_FILTER_KEY,
  TRANSLATIONS_UPDATE_FILTER_GROUP,
  TRANSLATIONS_UPDATE_FILTER_VALUE,
  TRANSLATIONS_UPDATE_FILTER_LOCALE
} from '@/store/mutypes';

@Component({
  name: 'translations',
  components: {
    NewTranslation,
    TranslationItem
  }
})
export default class Translations extends Vue {
  isLoading: boolean = false;

  @State(state => state.TranslationMod.translations)
  translations!: Translation[];

  @State(state => state.TranslationMod.locales)
  locales!: string[];

  @Getter('translationGroups')
  groups!: string[];

  @Getter('translationNamespaces')
  namespaces!: string[];

  @Getter
  activeLocales!: string[];

  @Getter
  filteredTranslations!: Translation[];

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch('getTranslations', {}),
      this.$store.dispatch('getLocales')
    ]);
    this.isLoading = false;
  }

  get tableData() {
    const keyMap = new Map<String, any>();
    for (const translation of this.filteredTranslations) {
      const key = `${translation.namespace}:${translation.group}:${
        translation.key
      }`;
      if (keyMap.has(key)) {
        const locales = keyMap.get(key);
        locales[translation.locale] = {
          value: translation.value,
          id: translation.id
        };
      } else {
        keyMap.set(key, {
          [translation.locale]: {
            value: translation.value,
            id: translation.id
          }
        });
      }
    }

    const tableData: any[] = [];
    keyMap.forEach((value, key) => {
      tableData.push({
        key,
        ...value
      });
    });
    return tableData;
  }

  async onNewTranslation(translation: Translation) {
    this.translations.push(translation);
  }

  onTranslationSaved(newTranslation: Translation) {
    let found = false;
    for (let translation of this.translations) {
      if (translation.id === newTranslation.id) {
        translation = newTranslation;
        found = true;
        break;
      }
    }

    if (!found) {
      this.$store.commit(TRANSLATIONS_ADD_TRANSLATIONS, newTranslation);
    }
  }

  queryNamespace(query: string, cb: Function) {
    let namespaces = this.namespaces;
    if (query) {
      namespaces = namespaces.filter((namespace: string | undefined) =>
        namespace!.toLowerCase().includes(query.toLowerCase())
      );
    }
    cb(
      namespaces.map(namespace => {
        return { value: namespace, label: namespace };
      })
    );
  }

  queryGroup(query: string, cb: Function) {
    let groups = this.groups;
    if (query) {
      groups = groups.filter((group: string | undefined) =>
        group!.toLowerCase().includes(query.toLowerCase())
      );
    }
    cb(
      groups.map(group => {
        return { value: group, label: group };
      })
    );
  }

  queryLocale(query: string, cb: Function) {
    let locales = this.activeLocales;
    if (query) {
      locales = locales.filter((locale: String) =>
        locale!.toLowerCase().includes(query.toLowerCase())
      );
    }
    return cb(
      locales.map(locale => {
        return { value: locale, label: locale };
      })
    );
  }

  get filterNamespace() {
    return this.$store.state.TranslationMod.filterNamespace;
  }

  set filterNamespace(namespace: string) {
    this.$store.commit(TRANSLATIONS_UPDATE_FILTER_NAMESPACE, namespace);
  }

  get filterGroup() {
    return this.$store.state.TranslationMod.filterGroup;
  }

  set filterGroup(group: string) {
    this.$store.commit(TRANSLATIONS_UPDATE_FILTER_GROUP, group);
  }

  get filterLocale() {
    return this.$store.state.TranslationMod.filterLocale;
  }

  set filterLocale(locale: string) {
    this.$store.commit(TRANSLATIONS_UPDATE_FILTER_LOCALE, locale);
  }

  get filterKey() {
    return this.$store.state.TranslationMod.filterKey;
  }

  set filterKey(key: string) {
    this.$store.commit(TRANSLATIONS_UPDATE_FILTER_KEY, key);
  }

  get filterValue() {
    return this.$store.state.TranslationMod.filterValue;
  }

  set filterValue(value: string) {
    this.$store.commit(TRANSLATIONS_UPDATE_FILTER_VALUE, value);
  }
}
